
<label class="toggle-button-wrapper">
  <input
    type="checkbox"
    [checked]="value"
    (change)="onChange($event)"
    [id]="groupidentifier + '-input-'"
  />
  
  <span class="toggle-button-text">
    <span class="toggle-button-text-on">&nbsp;</span>
    <span class="toggle-button-text-off">&nbsp;</span>
  </span>
  
  <span class="toggle-button-switch"></span>
</label>
